import PublicLayout from "@/components/layout/PublicLayout";
import { Link } from "react-router-dom";
import { Building2, Mail, MapPin } from "lucide-react";

const ADVISORY_IMG = "https://static.prod-images.emergentagent.com/jobs/41d00f51-e021-4a3a-9144-49fb07005586/images/2f859fbabe7b20d5b3182481de6602da4ac45382ad66af1a9bfd2c4cc9157961.png";

export default function OverOns() {
  return (
    <PublicLayout>
      <section className="oc-section">
        <div className="oc-container grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">Over ons</span>
            <h1 className="font-display font-bold text-[40px] sm:text-[52px] leading-tight tracking-tight text-oc-primary mt-3">
              Eerlijke prijzen<br/> voor iedereen.
            </h1>
            <p className="mt-5 text-oc-textSecondary text-[18px] leading-relaxed">
              Elk jaar worden Belgische en Nederlandse consumenten voor miljarden euro's te veel aangerekend op offertes. Niet altijd uit kwade wil — maar door gebrek aan transparantie, vergelijkingsbasis en onderhandelingskennis.
            </p>
            <p className="mt-4 text-oc-textSecondary text-[18px] leading-relaxed">
              OfferteExpert geeft iedereen toegang tot de informatie die vroeger alleen voor grote bedrijven beschikbaar was.
            </p>
          </div>
          <div className="rounded-oc overflow-hidden border border-oc-border shadow-oc-card">
            <img src={ADVISORY_IMG} alt="Advisory office" className="w-full h-[420px] object-cover" />
          </div>
        </div>
      </section>

      <section className="oc-section bg-white border-t border-oc-border">
        <div className="oc-container max-w-3xl">
          <h2 className="font-display font-bold text-oc-primary text-[28px]">Onze missie</h2>
          <p className="mt-3 text-oc-textPrimary text-[17px] leading-[1.7]">
            "Eerlijke prijzen voor iedereen. Geen verrassingen. Geen twijfels."
          </p>
          <h2 className="mt-12 font-display font-bold text-oc-primary text-[28px]">Het bedrijf</h2>
          <div className="mt-4 grid sm:grid-cols-2 gap-4">
            <div className="bg-oc-subtle border border-oc-border rounded-oc p-7 flex items-start gap-3">
              <Building2 className="w-5 h-5 text-oc-secondary mt-1" />
              <div>
                <p className="font-display font-semibold text-oc-primary">Webtron BV</p>
                <p className="text-oc-textSecondary text-[14px]">Eigenaar van OfferteExpert</p>
                <p className="text-oc-textSecondary text-[14px] mt-2">BTW BE0793944703</p>
              </div>
            </div>
            <div className="bg-oc-subtle border border-oc-border rounded-oc p-7 flex items-start gap-3">
              <MapPin className="w-5 h-5 text-oc-secondary mt-1" />
              <div>
                <p className="font-display font-semibold text-oc-primary">Adres</p>
                <p className="text-oc-textSecondary text-[14px]">A. Rodenbachwijk 12<br/>9792 Waregem<br/>België</p>
              </div>
            </div>
          </div>
          <h2 className="mt-12 font-display font-bold text-oc-primary text-[28px]">Contact</h2>
          <p className="mt-3 flex items-center gap-2 text-oc-textPrimary">
            <Mail className="w-4 h-4 text-oc-secondary" />
            <a href="mailto:info@offerteexpert.be" className="underline text-oc-secondary">info@offerteexpert.be</a>
            <span className="text-oc-textSecondary text-[14px]">· algemene vragen & support</span>
          </p>

          <Link
            to="/contact"
            className="mt-10 inline-flex items-center gap-2 text-oc-secondary hover:text-oc-primary font-semibold"
          >
            Naar contactformulier →
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
